module.exports = __webpack_public_path__ + "static/media/check.86717354.svg";